import i18n from 'i18next';

export const YES_NO_OPTIONS = [
  { value: true, label: i18n.t('Yes') },
  { value: false, label: i18n.t('No') },
];
